import { FilterOutlineIcon, SortIcon } from '@carboncopyco/icons';
import type { TopAssetType, TopAssetsSort } from '@carboncopyco/types';
import {
  DropdownFilter,
  type DropdownFilterItemContent,
  MultiDropdownFilter,
} from '@carboncopyco/ui';
import { TopAssetsTypeFilterOption } from './TopAssetsTypeFilterOption';
import { topAssetsSortOptions } from './consts';
import { useTableControls } from './useTopAssetsTableControls';

type TopAssetsTableControlsProps = {
  isEmpty: boolean;
  typeFilterOptions: DropdownFilterItemContent<TopAssetType>[];
};

export const TopAssetsTableControls = ({
  isEmpty,
  typeFilterOptions,
}: TopAssetsTableControlsProps) => {
  const { sort, setSort, selectedTypes, setSelectedTypes, resetSelectedTypes } =
    useTableControls();

  return (
    <>
      <DropdownFilter<TopAssetsSort>
        disabled={isEmpty}
        capsuleWidth={168}
        contentWidth={168}
        placeholder=""
        selected={sort}
        leftIcon={SortIcon}
        items={topAssetsSortOptions}
        onSelect={setSort}
      />
      <MultiDropdownFilter<TopAssetType>
        leftIcon={FilterOutlineIcon}
        disabled={isEmpty}
        capsuleWidth={168}
        contentWidth={168}
        placeholder="All types"
        fixedGroup={{ items: typeFilterOptions }}
        renderItem={TopAssetsTypeFilterOption}
        selectedItems={selectedTypes}
        onChange={setSelectedTypes}
        onClear={resetSelectedTypes}
      />
    </>
  );
};
